import { useAdmin } from "@/hooks/admin";
import {
  Datagrid,
  DateField,
  FunctionField,
  ListBase,
  TextField,
  useNotify,
} from "react-admin";
import { CustomPagination } from "@/resources/shared/pagination";
import { TAgentConnection } from "@/api";
import { Box } from "@mui/material";
import { EditConnectionModal } from "./actions/edit-connection";
import { CONNECTIONS } from "@/config/resources";
import { useListContext } from "react-admin";

type Props = {
  supplierId: string;
};

const AgentConnectionsDatagrid = ({ supplierId }: { supplierId: string }) => {
  const { data, refetch } = useListContext<TAgentConnection>();

  return (
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
    >
      <TextField source="name" label="Nombre" />
      <FunctionField
        label="Agente"
        render={(connection: TAgentConnection) =>
          connection.agent?.name || connection.agent?.key || "-"
        }
      />
      <FunctionField
        label="Estado"
        render={(connection: TAgentConnection) =>
          connection.status === "active" ? "Activo" : "Inactivo"
        }
      />
      <DateField source="createdAt" label="Fecha de creación" />
      <FunctionField
        label="Acciones"
        render={(connection: TAgentConnection) => (
          <EditConnectionModal
            connection={connection}
            supplierId={supplierId}
            onSuccess={() => refetch()}
          />
        )}
      />
    </Datagrid>
  );
};

export const SupplierAgentConnectionsList = ({ supplierId }: Props) => {
  const { hasPermission } = useAdmin();

  return (
    <ListBase
      resource={CONNECTIONS}
      queryOptions={{ meta: { dependentId: supplierId } }}
      disableSyncWithLocation
      perPage={20}
    >
      <AgentConnectionsDatagrid supplierId={supplierId} />
      <CustomPagination />
    </ListBase>
  );
};

